import { Pipe, PipeTransform } from '@angular/core';
import {EnergieEnum} from '../suivi-des-consommations/enums/EnergieEnum';

@Pipe({
    name: 'energieName',
    standalone: false
})
export class EnergieNamePipe implements PipeTransform {

  transform(energie: EnergieEnum, ...args: unknown[]): unknown {
    switch (energie){
      case EnergieEnum.ELECTRICITE: return 'Électricité';
      case EnergieEnum.GAZ: return 'Gaz';
      case EnergieEnum.EAU: return 'Eau';
      case EnergieEnum.RESEAU_CHALEUR: return 'Réseau chaleur';
      case EnergieEnum.BOIS: return 'Bois';
      case EnergieEnum.FIOUL: return 'Fioul';
      case EnergieEnum.HYBRIDE: return 'Hybride';
      case EnergieEnum.HYBRIDE2: return 'Hybride 2';
      case EnergieEnum.CHAUFFAGE: return 'Chauffage';
      case EnergieEnum.ECS: return 'Eau chaude sanitaire';
      case EnergieEnum.REFROIDISSEMENT: return 'Climatisation';
    }
  }

}
